import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stkle } from '../entity/Stkle-angular';


@Injectable({
  providedIn: 'root'
})
export class StkleServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Stkle();
    this.entityType.type = EntityType.data;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      LE001: '交易日期', LE002: '時間', LE003: '股票代號', LE004: '條件名稱', LE005: '流程碼', LE006: '股票名稱', LE007: '內容', LE008: '已讀', LE009: '已傳', LE010: '條件代號', LE011: '序號', LE012: '已說次數', LE013: '價格'
    };

    this.fieldNames = 'LE001,LE002,LE003,LE004,LE005,LE006,LE007,LE008,LE009,LE010,LE011,LE012,LE013';
    this.fieldLengths = { LE001: 8, LE002: 8, LE003: 10, LE004: 20, LE005: 1, LE006: 10, LE007: 200, LE008: 1, LE009: 1, LE010: 6, LE011: 4, LE012: 2, LE013: 11.2 };
    this.columnDefs = [
      { field: "LE001", headerName: "交易日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "LE002", headerName: "時間", headerTooltip: "", width: 134, cellDataType: "text", },
      { field: "LE003", headerName: "股票代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "LE006", headerName: "股票名稱", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "LE008", headerName: "已讀", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "LE009", headerName: "已傳", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "LE010", headerName: "條件代號", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "LE004", headerName: "條件名稱", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "LE012", headerName: "已說次數", headerTooltip: "", width: 86, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "LE013", headerName: "價格", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "LE005", headerName: "流程碼", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "LE007", headerName: "內容", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "LE011", headerName: "序號", headerTooltip: "", width: 102, cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'STKLE';
    this.isSys = false;
    this.sqlSelect = `SELECT TOP 1000 STKLE.*  FROM STKLE
` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY LE001 DESC,LE002 DESC,LE011`;
    this.keyFields = ['LE001', 'LE002', 'LE011'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['LE001', 'LE002', 'LE011'];
    this.seqField = 'LE011';
    this.seqFieldLength = 4;
  }
  override async validateItem(item: Stkle): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Stkle): Promise<Stkle> {
    await super.newRecord(newItem);
    return newItem;
  }




}
